import { render, staticRenderFns } from "./Pesquisas.vue?vue&type=template&id=1ea2b499&"
import script from "./Pesquisas.vue?vue&type=script&lang=js&"
export * from "./Pesquisas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports